import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '@/lib/AuthContext'

interface ProtectedRouteProps {
  children: ReactNode
}

/**
 * Gate — redirect to `/` (the public landing + sign-in surface) if
 * there's no authenticated user. Keeps the target path in location
 * state so LoginPage can bounce the user back after a successful
 * sign-in.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-sm text-slate-400">Loading...</div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
